import cloneDeep from 'lodash/cloneDeep'

class CompanyCloudcanteenFormMapper {
    toEntity(values) {
        const entity = cloneDeep(values)

        entity.pickupOffset = parseInt(entity.pickupOffset)
        entity.recurringOccasionLimit = parseInt(entity.recurringOccasionLimit)
        entity.recurringDayLimit = parseInt(entity.recurringDayLimit)

        for (let override of entity.budgetOverrides) {
            if (typeof override['@id'] === 'number') {
                delete override['@id']
            }
        }

        return entity
    }

    fromEntity(entity) {
        return cloneDeep(entity)
    }
}

export default new CompanyCloudcanteenFormMapper()
